import type { TutorialCategory } from "@/api/dashboard-home";

/** Toutes les rubriques (filtre « Tous » de la modale des tutoriels). */
export const ALL_CATEGORIES = "__all__";

/**
 * Recherche insensible à la casse, aux accents, aux ligatures (« oeuvre »
 * trouve « œuvre ») et au type d'apostrophe (« d'accueil » trouve « d’accueil »,
 * la typographie de WordPress et des traducteurs).
 */
export function normalizeForSearch(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/œ/g, "oe")
    .replace(/æ/g, "ae")
    .replace(/[\u2018\u2019\u02bc\u0060\u00b4]/g, "'");
}

/** Rubriques filtrées (rubrique choisie + texte), sans les rubriques vides. */
export function filterTutorials(
  categories: TutorialCategory[],
  category: string,
  query: string,
): TutorialCategory[] {
  const q = normalizeForSearch(query.trim());
  return categories
    .filter((c) => category === ALL_CATEGORIES || c.title === category)
    .map((c) => ({
      ...c,
      items: q
        ? c.items.filter((item) => normalizeForSearch(item.title).includes(q))
        : c.items,
    }))
    .filter((c) => c.items.length > 0);
}

export function countTutorials(categories: TutorialCategory[]): number {
  return categories.reduce((total, c) => total + c.items.length, 0);
}
